import { render, staticRenderFns } from "./IntrodcutionMethod.vue?vue&type=template&id=146c468b&"
import script from "./IntrodcutionMethod.vue?vue&type=script&lang=js&"
export * from "./IntrodcutionMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports